import $ from 'jquery';
import Q from 'q';

var LayoutManager = function() {
    this._layouts = [];
    this._currentLayout = null;
    this._switchingLayout = false;
    this._started = false;

    this.$window = $(window);
};

/* -------------------------
    STATIC
------------------------- */

$.extend(LayoutManager, {

    /**
     * @event layout:change
     *
     * Évènement dispatché sur window.
     *
     * @param event Évènement jQuery.
     * @param layout Classe du layout.
     */
    CHANGE: 'layout:change',

});


/* -------------------------
    INSTANCE
------------------------- */

$.extend(LayoutManager.prototype, {

    _resizeHandler: function() {
        this.invalidate();
    },

    start: function() {
        if (this._started) return Q.reject();

        this._started = true;

        this.$window.on('resize', $.proxy(this._resizeHandler, this));

        return this.invalidate();
    },

    stop: function() {
        // A implémenter
    },

    setLayouts: function(layouts) {
        this._layouts = layouts;
    },

    getAvailableLayout: function() {
        var availableLayout = null;

        $.each(this._layouts, function(i, layout) {
            if (layout.isAvailable()) {
                availableLayout = layout;
                return false; // équivalent de break
            }
        });

        return availableLayout;
    },

    invalidate: function() {
        if (this._switchingLayout) return Q.resolve();

        var oldLayout = this._currentLayout;
        var newLayout = this.getAvailableLayout();

        // s'il y a des changements...
        if (oldLayout !== newLayout) {
            this._currentLayout = newLayout;
            this._switchingLayout = true;

            var self = this;

            if (newLayout && !oldLayout) {
                // active le nouveau
                return newLayout.activate()
                    .then(function() {
                        self._switchingLayout = false;
                        $(document.body)
                            .addClass(newLayout.bodyClass)
                            .data('layout', newLayout.name)
                            .trigger(LayoutManager.CHANGE, [newLayout.name]);
                    })
                    .fail(function(reason) {
                        console.error(reason.stack ? reason.stack : reason);
                    });
            }
            else if (newLayout && oldLayout) {
                // désactive l'ancien et active le nouveau
                return oldLayout.deactivate()
                    .then(function(){
                        $(document.body).removeClass(oldLayout.bodyClass);
                        return newLayout.activate();
                    })
                    .then(function() {
                        self._switchingLayout = false;
                        $(document.body)
                            .addClass(newLayout.bodyClass)
                            .data('layout', newLayout.name)
                            .trigger(LayoutManager.CHANGE, [newLayout.name]);
                    })
                    .fail(function(reason) {
                        console.error(reason.stack ? reason.stack : reason);
                    });
            }
            else if (oldLayout) {
                // désactive l'ancien
                return oldLayout.deactivate()
                    .then(function() {
                        self._switchingLayout = false;
                        $(document.body)
                            .removeClass(oldLayout.bodyClass)
                            .data('layout', null)
                            .trigger(LayoutManager.CHANGE, [null]);
                    })
                    .fail(function(reason) {
                        console.error(reason.stack ? reason.stack : reason);
                    });
            }
        }

        return Q.resolve();
    },

});


// export
export default new LayoutManager();


// WEBPACK FOOTER //
// ./scripts/scuba/LayoutManager.js